
export enum RoomEditTarget {
	Pipe,
	Intersection,
	Feature,
	FeatureGloop
}
